/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "../../BaseCom";
import FormInput from "../../FormInput";
import React from "react";
import { qreq } from "../../../shared/qrequest";
import { EditorGlobal } from "../../Editor";
import Icon from "../../Icon";
import L from "../../Lang";

export default class ItemMenuManager extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            itemMenu: {
                list: []
            }
        };
        this.fileRef = React.createRef();
    }

    async componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialProps !== prevProps.initialProps) {
            this.setState({ itemMenu: { ...this.props.initialProps } });
        }
    }

    submit = (e) => {
        e?.preventDefault();
        this.props.col.extendedProps = { ...this.state.itemMenu }; // extendedProps is a custom property that can be used to store additional data
        console.log(this.props.col.extendedProps);
        this.props.onSubmit();
    }

    import = () => {
        this.fileRef.current.click();
    }

    process = (e) => {
        e?.preventDefault();
        if (!e.target.files?.length) return;


        var reader = new FileReader();
        reader.onload = async (data) => {
            this.setState({ processing: true });
            try {
                let j = await qreq.postAsync('/api/item-menu/process', { siteDomainID: EditorGlobal.siteDomainID, data: data.target.result });
                if (j.list) {
                    let itemMenu = { ...this.state.itemMenu, list: [...this.state.itemMenu.list, ...j.list] };
                    this.setState({ itemMenu });
                }
                else
                    this.alert(j.errorMessage);
                this.fileRef.current.value = '';
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
            this.setState({ processing: false });
        };
        reader.readAsDataURL(e.target.files[0]);
    }

    addItem = (item) => {
        let itemMenu = { ...this.state.itemMenu };
        itemMenu.list.push({});
        this.setState({ itemMenu });
    }

    removeItem = (item) => {
        let itemMenu = { ...this.state.itemMenu };
        itemMenu.list.splice(itemMenu.list.indexOf(item), 1);
        this.setState({ itemMenu });
    }

    clear = () => {
        let itemMenu = { ...this.state.itemMenu };
        itemMenu.list = [];
        this.setState({ itemMenu });
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.submit} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title><L>Item Menu Manager</L></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="list-group">
                        {this.state.itemMenu?.list?.map((i, idx) => (
                            <div key={idx} className="list-group-item d-flex justify-content-between">
                                <div className="flex-fill">
                                    <FormInput
                                        model={i}
                                        type="text"
                                        name="name"
                                        label="Item Name"
                                        labelAsPlaceholder
                                        required />
                                </div>
                                <div>
                                    <FormInput
                                        model={i}
                                        type="text"
                                        name="price"
                                        label="Price"
                                        labelAsPlaceholder
                                        required />
                                </div>
                                <div>
                                    <button type="button" className="btn btn-danger" onClick={() => this.removeItem(i)}>
                                        <Icon icon="faTrash" />
                                    </button>
                                </div>
                            </div>
                        ))}
                        {this.state.processing && <div className="ai-loader-container">
                            <div className="ai-loader"></div>
                            <p className="text-muted"><L>Processing...</L></p>
                        </div>}
                    </div>
                    <div className="d-flex gap-1 mt-3">
                        <div style={{ display: 'none' }}><input type="file" ref={this.fileRef} onChange={this.process} /></div>
                        <button type="button" className="btn btn-primary" onClick={this.import}><Icon icon="faUpload" /> <L>Import</L></button>
                        <button type="button" className="btn btn-secondary" onClick={this.addItem}><Icon icon="faPlus" /> <L>Add Item</L></button>
                        <button type="button" className="btn btn-secondary" onClick={this.clear}><Icon icon="faBroom" /> <L>Clear</L></button>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}